/*!
 * IVONO Shopify-theme  ·  gebouwd door DIEK.nl
 * Copyright (c) 2026 DIEK.nl  ·  https://diek.nl
 */

/**
 * IVONO motion system — docs/build/motion-spec.md
 * Eén IntersectionObserver die `.is-inview` op sectie-niveau zet (eenmalig),
 * en `[data-iv-stagger]`-kinderen een `--iv-stagger-i` geeft (index per groep).
 *
 * Contract met assets/iv-motion.css:
 * - Initial-hidden styles gelden ALLEEN onder `html.iv-motion-ready` — die
 *   class wordt hier gezet. Zonder JS, in de Shopify theme editor
 *   (Shopify.designMode) of bij prefers-reduced-motion blijft alles direct
 *   zichtbaar en speelt er niets.
 * - Na de entrance krijgt de sectie `.is-settled`: content die daarna via
 *   AJAX opnieuw rendert (cartpagina, tab-panels) toont direct de eindstaat.
 */
(function () {
  'use strict';

  // Geen entrance-animaties in de theme editor.
  if (window.Shopify && window.Shopify.designMode) return;

  var REVEAL_SELECTOR = '.iv-reveal-up, .iv-reveal-fade, .iv-reveal-card';

  function init() {
    // Stagger-indices: per parent-groep tellen (product-cards, menu-items).
    var groupCounts = [];
    var groupKeys = [];
    document.querySelectorAll('[data-iv-stagger]').forEach(function (el) {
      var key = el.parentElement || document.body;
      var idx = groupKeys.indexOf(key);
      if (idx === -1) {
        groupKeys.push(key);
        groupCounts.push(0);
        idx = groupKeys.length - 1;
      }
      el.style.setProperty('--iv-stagger-i', groupCounts[idx]);
      groupCounts[idx] += 1;
    });

    // Reduced motion: geen ready-class -> geen initial-hidden, geen animaties.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.documentElement.classList.add('iv-motion-ready');

    // Verzamel de secties die reveal-elementen bevatten.
    var sections = [];
    document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
      var section = el.closest('.shopify-section');
      if (!section) {
        // Vangnet: element buiten een sectie-wrapper -> direct eindstaat.
        el.classList.add('is-settled');
        return;
      }
      if (sections.indexOf(section) === -1) sections.push(section);
    });

    function settleDelay(section) {
      // Wacht tot de langste entrance klaar is: koppen max 250+430=680ms,
      // kaarten 300ms + hoogste stagger-index * 82ms.
      var maxIndex = 0;
      section.querySelectorAll('.iv-reveal-card[data-iv-stagger]').forEach(function (card) {
        var i = parseInt(card.style.getPropertyValue('--iv-stagger-i'), 10) || 0;
        if (i > maxIndex) maxIndex = i;
      });
      return Math.max(680, 300 + maxIndex * 82) + 200;
    }

    function reveal(section) {
      section.classList.add('is-inview');
      window.setTimeout(function () {
        section.classList.add('is-settled');
      }, settleDelay(section));
    }

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          reveal(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  // Shopify's video_tag stopt in elk video-element een fallback-<img> zonder
  // alt-attribuut; die is puur decoratief (de video draagt de inhoud) maar
  // telt als WCAG-fout (axe image-alt, meting 20/08). Server-side is dat
  // attribuut niet te zetten, dus hier: leeg alt = expliciet decoratief.
  function markVideoFallbacks() {
    document.querySelectorAll('video > img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      markVideoFallbacks();
    });
  } else {
    init();
    markVideoFallbacks();
  }
})();

/* Signatuur in de console. Niet zichtbaar op de pagina, geen invloed op SEO.
   Staat uit in de theme editor, zodat de merchant er geen last van heeft. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  try {
    console.log(
      '%cIVONO%c  ·  theme gebouwd door DIEK.nl  ·  https://diek.nl',
      'background:#008037;color:#fff;padding:2px 6px;border-radius:3px;font-weight:600',
      'color:#2B2723'
    );
  } catch (e) {}
})();
